import { useQuery } from '@tanstack/react-query';
import { env } from '@/common/config';
import { getUserProfile } from '../api';

export function useCurrentUserProfile() {
  const { data: profile } = useQuery({
    queryKey: ['profile'],
    queryFn: getUserProfile,
    staleTime: 5 * 60 * 1000,
  });

  let userObj = null;
  try {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      userObj = JSON.parse(storedUser);
    }
  } catch {
    userObj = null;
  }

  const firstName = profile?.first_name ?? userObj?.first_name ?? '';
  const lastName = profile?.last_name ?? userObj?.last_name ?? '';
  const displayName =
    (firstName.trim() + ' ' + lastName.trim()).trim() ||
    profile?.username ||
    userObj?.username ||
    profile?.email ||
    userObj?.email ||
    'User';

  const companyName =
    localStorage.getItem('company_name') ||
    profile?.company_name ||
    userObj?.company_name ||
    'Company';

  const rawImage =
    profile?.profile_image ||
    profile?.profile_picture ||
    userObj?.profile_image ||
    userObj?.profile_picture ||
    null;

  const avatarUrl = rawImage
    ? rawImage.startsWith('http')
      ? rawImage
      : `${env.photoBaseUrl}${rawImage}`
    : null;

  return { displayName, companyName, avatarUrl };
}
